export const GENERAL_INQUIRY = "generalInquiry";
export const STAY_VOUCHER_INQUIRY = "stayVoucherInquiry";
export const CRUISE_INQUIRY = "cruiseInquiry";
export const DAILY_BOAT_TRIP_INQUIRY = "dailyBoatTrips";
export const MEETINGS_INQUIRY = "meetingsEvents";
export const WEDDING_INQUIRY = "wedding";
export const BOAT_CHARTER = "boatCharter";
export const DINING_INQUIRY = "dining";
export const EXPERIENCE_INQUIRY = "experience";
export const SPA_INQUIRY = "spa";
